/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const CustomPricingSort = {
    Id: 'id',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at',
    Title: 'title',
    SessionName: 'session_name'
} as const;

export type CustomPricingSort = typeof CustomPricingSort[keyof typeof CustomPricingSort];



